import { Component, computed, inject, input, output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { RouterLink } from '@angular/router';
import { ENVIRONMENT } from '../../../../environments/environment.interface';
import { InstitutionPerson } from '../../../api/app-types/institution.app';
import { Paginator } from '../../../core/components/paginator/paginator';
import { PaginatedResponse } from '../../../shared/pagination/paginated-response';
import { InstitutionPersonsItem } from '../institution-persons-item/institution-persons-item';

@Component({
	selector: 'lvr-institution-persons-list',
	imports: [InstitutionPersonsItem, Paginator, RouterLink],
	templateUrl: './institution-persons-list.html',
	styleUrl: './institution-persons-list.scss',
})
export class InstitutionPersonsList {
	private readonly environment = inject(ENVIRONMENT);

	public readonly personsPage = input<PaginatedResponse<InstitutionPerson>>();
	public readonly persons = computed(() => (this.personsPage()?.entities ?? []).filter((p) => !p.isDeactivated));
	public readonly totalItems = computed(() => this.personsPage()?.totalEntities ?? 0);
	public readonly institutionName = input<string>('');

	public readonly pageIndex = computed(() => this.personsPage()?.offset ?? 0);
	public readonly pageSize = computed(() => this.personsPage()?.range ?? this.environment.defaultPageSize);

	public readonly showFirstLastButtons = true;
	public readonly hidePageSize = false;

	public readonly pageRequested = output<{ pageIndex: number; pageSize: number }>();

	public handlePageEvent(event: PageEvent) {
		this.pageRequested.emit({ pageIndex: event.pageIndex, pageSize: event.pageSize });
	}
}
